import { ActivateFullScreen, DeactivateFullScreen } from 'src/components/svg/FullScreens';

export const FullScreenButton = ({
  isFullScreen,
  onFullscreenOpen,
  onFullscreenClose
}: {
  isFullScreen: boolean;
  onFullscreenOpen: () => void;
  onFullscreenClose: () => void;
}) => {
  return !isFullScreen ? (
    <button onClick={onFullscreenOpen} title="on fullscreen">
      <ActivateFullScreen />
    </button>
  ) : (
    <button onClick={onFullscreenClose} title="deactivate fullscreen">
      <DeactivateFullScreen />
    </button>
  );
};
